import { gql } from 'graphql-tag';
import { ASSET_FRAGMENT, SEARCH_RESULT_FRAGMENT } from "../../../common/fragments.graphql";
import { graphql } from "../../common/gql";


export const GET_SEARCH_FACET_VALUES = graphql(`
    query GetSearchFacetValues($input: SearchInput!) {
        search(input: $input) {
            totalItems
            facetValues {
                count
                facetValue {
                    id
                    name
                    facet {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const GET_COLLECTION = gql`
    query GetCollection($id: ID, $slug: String) {
        collection(id: $id, slug: $slug) {
            id
            name
            slug
            description
            featuredAsset {
                ...Asset
            }
            breadcrumbs {
                id
                name
                slug
            }
            children {
                id
                slug
                featuredAsset {
                    ...Asset
                }
                customFields {
                    noIndex
                    excludeFromSubCollections
                }
                name
            }
            customFields {
                layout
                noIndex
                filterPresets {
                    id
                    position
                    title
                    facetValues {
                        id
                        facet {
                            id
                        }
                    }
                }
                featuredFacets {
                    id
                }
                excludedFacets {
                    id
                }
                seoTitle
                seoDescription
                seoImage {
                    id
                    preview
                }
                extendedDescription
            }
        }
    }
    ${ASSET_FRAGMENT}
`;

export const ARTICLE_RESULT_FRAGMENT = gql`
    fragment ArticleResult on CmsArticlesResult {
        breadcrumb
        title
        slug
        highlights {
            field
            snippet
        }
    }
`;

export const SEARCH_PRODUCTS = graphql(`
    query SearchProducts($input: SearchInput!, $inputExternal: ExternalSearchInput!) {
        search(input: $input) {
            cacheIdentifier {
                collectionSlug
            }
            items {
                ...SearchResult
            }
            queryId
            totalItems
            facetValues {
                count
                facetValue {
                    id
                    name
                    facet {
                        id
                        name
                    }
                }
            }
            prices {
                rangeWithTax {
                    min
                    max
                }
            }
            topCollections {
                collection {
                    id
                    name
                    slug
                }
                score
            }
        }
        searchExternal(input: $inputExternal) {
            ... on CmsArticlesResponse {
                items {
                    ...ArticleResult
                }
                totalItems
            }
        }
    }
`);

export const LOG_SEARCH_RESULT_CLICK = gql`
    mutation LogSearchResultClick($input: SearchResultClickedEventInput!) {
        logSearchResultClicked(input: $input)
    }
`;

export const LOG_SEARCH_LIST_VIEWED = gql`
    mutation LogSearchListViewed($input: SearchListViewedEventInput!) {
        logSearchListViewed(input: $input)
    }
`;
